module.exports = __webpack_public_path__ + "media/images/logos/Institute-of-Teacher-Education-6e70642b1486452d0ab6df70ed9ac101.svg";